import React, { useContext, useEffect } from "react";
import Box from "@mui/material/Box/Box";
import GenieText from "../../components/core/genie-text/GenieText";
import { Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GenieSpinner from "../../components/core/genie-spinner/GenieSpinner";
import { SecurityContext } from "../Base";
import GenieCanvas from "../../components/core/genie-canvas/GenieCanvas";

function Authentication() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const securityContext = useContext(SecurityContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteOrgId = searchParams.get("invite_org_id");

  // Handle authentication and routing logic
  useEffect(() => {
    // invite_org_id indicates there's an immediate invite and we need to redirect later to that storefront
    if (inviteOrgId) {
      localStorage.setItem("invite_org_id", inviteOrgId);
    }

    // Only proceed if Auth0 is not loading
    if (!isLoading) {
      if (isAuthenticated) {
        //Keep this simple and have all the redirect logic in CreateOrg
        // // Check if user has organizations and redirect to welcome page
        // if (securityContext?.user?.organizations && securityContext.user.organizations.length > 0) {
        //   return navigate(`/app/${securityContext.user.organizations[0].id}/welcome`);
        // }
        // // User is authenticated but no organizations, handle redirect based on org_id
        // if (orgId) {
        //   // If org_id is provided, redirect to storefront
        //   navigate(`/details?org_id=${orgId}`);
        // } else {
        //   // No org_id, redirect to details as before
        return navigate("/details");
      }
    }
  }, [isAuthenticated, isLoading, navigate, inviteOrgId, securityContext]);

  // Show loading spinner while Auth0 is initializing
  if (isLoading) {
    return <GenieSpinner />;
  }

  // Show loading spinner if user is authenticated (they will be redirected)
  if (isAuthenticated) {
    return <GenieSpinner />;
  }
  return (
    <GenieCanvas imageUrl={'url("/assets/home.jpg")'}>
      <Box>
        <img
          height={"40px"}
          src={`/assets/genie_logo.svg`}
          alt={"Genie Logo"}
        />
        <Box mt={2}>
          <GenieText fontSize={"large"} fontWeight={"bold"} paragraph>
            Automate Your Wholesale
          </GenieText>
        </Box>
        <GenieText paragraph fontSize={"small"}>
          Upload your catalog, customize your terms, and allow your retailers to
          order online.
        </GenieText>
        <GenieText fontSize={"small"} subdued>
          Sign up today for free to start selling wholesale on your terms.
        </GenieText>
        <Box display={"flex"} mt={2}>
          <Button
            variant={"outlined"}
            size={"large"}
            onClick={() =>
              loginWithRedirect({
                screen_hint: "signup",
              })
            }
          >
            Sign Up
          </Button>
          <Button
            sx={{ ml: 2 }}
            variant={"outlined"}
            size={"large"}
            onClick={() => loginWithRedirect()}
          >
            Login
          </Button>
        </Box>
      </Box>
    </GenieCanvas>
  );
}

export default Authentication;
